export default __webpack_public_path__ + "static/media/img-b-02-charging-bg@3x.d55ebb25.png";